<template>
    <div id="header" class="header sticky-top">
        <div class="col">
            <img src="../../assets/images/logo.png" style="padding-top: 15px;padding-bottom:15px;height:90px;weight:90px">
        </div>

        <nav class="navbar navbar-expand-sm">
            <!-- Links -->
            <ul class="navbar-nav">
                <!-- Dropdown -->
                <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
                    {{ $t('headers.menu') | uppercase }}
                </a>
                <div class="dropdown-menu">
                    <router-link :to="`/${$i18n.locale}/reason`" class="dropdown-item">{{ $t('menu.reason') }}</router-link>
                    <router-link :to="`/${$i18n.locale}/project`" class="dropdown-item">{{ $t('menu.project') }}</router-link>
                    <router-link :to="`/${$i18n.locale}/company`" class="dropdown-item">{{ $t('menu.company') }}</router-link>
                    <router-link :to="`/${$i18n.locale}/employee`" class="dropdown-item">{{ $t('menu.employee') }}</router-link>
                    <router-link :to="`/${$i18n.locale}/user`" class="dropdown-item">{{ $t('menu.user') }}</router-link>
                    <router-link :to="`/${$i18n.locale}/history`" class="dropdown-item">{{ $t('menu.clocking records') }}</router-link>
                    <router-link :to="`/${$i18n.locale}/export/list`" class="dropdown-item">{{ $t('menu.export setup listing') }}</router-link>
                    <router-link :to="`/${$i18n.locale}/export/verify`" class="dropdown-item">{{ $t('menu.export clock data') }}</router-link>
                    <router-link :to="`/${$i18n.locale}/analysis`" class="dropdown-item">{{ $t('menu.clocking analysis') }}</router-link>
                    <router-link :to="`/${$i18n.locale}/integrationsetup`" class="dropdown-item">{{ $t('menu.integration setup') }}</router-link>
                    <router-link :to="`/${$i18n.locale}/dailysecmonrpt`" class="dropdown-item">{{ $t('menu.daily security monitoring report') }}</router-link>
                     <router-link :to="`/${$i18n.locale}/geolocation`" class="dropdown-item">{{ $t('menu.geolocation') }}</router-link>
                    <!--router-link :to="`/${$i18n.locale}/#`"  class="dropdown-item" -->
                        <span v-on:click="onChangePassword" class="dropdown-item" style="cursor:pointer">{{ $t('menu.change password') }}</span>
                    <!-- /router-link -->
                </div>
                </li>
            </ul>
            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <!-- app-lang-switcher class="language_text_inversion" / -->
                </li>
                <li class="nav-item">
                    <router-link :to="`/${$i18n.locale}/home`" exact class="nav-link">{{ $t('headers.home') | uppercase }} <span class="sr-only">(current)</span></router-link>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/" @click="logout">{{ $t('headers.logout') | uppercase }}</a>
                </li>
                <!-- <li class="nav-item"> -->
                <!-- <p style="color: white; margin: 0px; padding: 7px;">Licensed state: {{ this.$store.state.licenseName }}</p>
                <p style="color: white; margin: 0px; padding: 7px;">Licensed getters: {{ this.$store.getters.licenseName }}</p> -->
                <!-- <p style="color: white; margin: 0px; padding: 7px;">LICENSED: {{ licenseName }}</p> -->
                <!-- </li> -->
            </ul>
        </nav> 
        <v-dialog v-model="dialogPassword" max-width="400px">
            <v-card>
                <v-card-title><h5>{{ dialogTitle }} for {{ this.$store.state.username }}</h5></v-card-title>
                <v-card-text>
                    <div class="form-group" v-if="!this.isSuccess">
                        <input type="password" class="form-control" placeholder="Current Password" v-model="currentPassword">                            
                    </div>

                    <div class="form-group" v-if="!this.isSuccess">
                        <input type="password" class="form-control" placeholder="New Password" v-model="newPassword">                            
                    </div>

                    <div class="form-group" v-if="!this.isSuccess">
                        <input type="password" class="form-control" placeholder="Confirm New Password" v-model="confirmPassword">                            
                    </div>

                    <div class="form-group">
                        <span v-if="this.errormsg" align="center"><p class="text-danger">{{ errormsg }}</p></span>
                        <span v-if="this.okmsg" align="center"><p class="text-primary">{{ okmsg }}</p></span>
                    </div>

                    <div class="form-group">
                        <center>
                            <button v-if="!this.isSuccess" class="btn btn-primary" @click="changePasswordHandler">SUBMIT</button>
                            <button class="btn btn-danger" @click="closeDialogPasswordHandler">CANCEL / CLOSE</button>
                        </center>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import axios from 'axios';

import LanguageSwitcher from '../shared/LanguageSwitcher';

export default {
    components: {
        'app-lang-switcher': LanguageSwitcher
    },

    data () {
    return {
        dialogTitle: 'CHANGE PASSWORD',
        dialogPassword: false,
        userName: null,
        userId: null,
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        errormsg: null,
        okmsg: null,
        isSuccess: false,
        //licenseName:  this.$store.getters.licenseName || "Not Found",
        licenseName : localStorage.getItem('licenseName') || 'N/A'
    }
    },

    methods: {
        onChangePassword() {
            this.dialogPassword = true;
        },

        closeDialogPasswordHandler() {
            this.dialogPassword = false;
        },

        changePasswordHandler() {
        if (!this.currentPassword && !this.newPassword && !this.confirmPassword) {
            this.errormsg = 'All fields required'
        } else {
            if (this.confirmPassword !== this.newPassword) {
                this.errormsg = "New password and confirm password mismatch. Please try again"
            } else {
                const vm = this;

                axios.post(this.$store.getters.rootAPI + '/admin/change_password', {
                    user_id: vm.userId,
                    password: vm.currentPassword,
                    new_password: vm.newPassword
                })
                .then (function (response){
                    if (response.status == 200) {
                        vm.errormsg = null;
                        vm.okmsg = "Password change successful";
                        vm.isSuccess = true;
                    }
                })
                .catch(function(error) {
                    vm.errormsg = "Current password invalid. Please try again"
                })
            }
        }
        },

        retriveUserIdHandler() {
        let jwtCode = require('jwt-decode')
        let decodedToken = jwtCode(this.$store.state.token)
        
        this.userId = decodedToken.id;
        },

        logout() {
        this.$store.dispatch('deleteUserName')
        this.$store.dispatch('deleteToken')
        //this.$router.push('/')
        }
    },

    mounted() {
        this.retriveUserIdHandler();
    }
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/shared/Header.vue